<template>
    <Bank :id="Number(id)"/>
</template>
<script>
import Bank from '@/components/BankCredits.vue';

export default {
    components: {
        Bank
    },
    name: 'BankCreditsProfileView',
    data() {
        return {
            // Инициализация компонента Bank с id 0 для добавления нового банка
            id: this.$route.params.id || '0'
        }
    }
}
</script>